export const userRoles = {
    CHILD_ACCOUNT : 'child account'
}

export const subscriptionType = {
    WHITE_LABEL_ACCOUNT: "white label account",
    WHITE_LABEL_CHILD_ACCOUNT: "white label child account",
    YEAR: "year",
    MONTH: "month",
    DEFAULT_VALUE: 'N/A',
};

export const subscriptionTerms = {
    TERM1 : 'term1',
    TERM2 : 'term2',
    TERM3 : 'term3',
    TERMCHILD1: 'termChild1',
    TERMCHILD2: 'termChild2',
}

export const WORK_FLOW_LOCATION_ACCOUNT = {
    ACTIVE_LOCATION_SUBSCRIPTION: 'ACTIVE_LOCATION_SUBSCRIPTION',
    CHILD_ACCOUNTS_DETAIL_PAGE:'CHILD_ACCOUNTS_DETAIL_PAGE',
    LOCATION_ACCOUNT_SUBSCRIPTION: 'LOCATION_ACCOUNT_SUBSCRIPTION',
    PURCHASE_LOCATION:'PURCHASE_LOCATION',
}

export const WORK_FLOW_MASTER_ACCOUNT = {
    ACTIVE_MAIN_SUBSCRIPTION: 'ACTIVE_MAIN_SUBSCRIPTION',
    MASTER_ACCOUNT_SUBSCRIPTION: 'MASTER_ACCOUNT_SUBSCRIPTION',
}

export const WORK_FLOW_COMMON_SCREENS = {
    CARDS: 'CARDS',
    PAYMENT_INFO: 'PAYMENT_INFO',
    PAYMENT_METHOD_EDIT: 'PAYMENT_METHOD_EDIT',
    ADD_PAYMENT_METHOD: 'ADD_PAYMENT_METHOD',
}